export default "__VITE_ASSET__BjvMNwK6__"